import { FormGroup } from '@angular/forms';

export enum ExportDialogTypeEnum {
  users = 'users',
  groups = 'groups',
  locations = 'locations',
  equipments = 'equipments',
  quotations = 'quotations',
  recurrences = 'recurrences',
  maintenances = 'maintenances',
  maintenancesImr = 'maintenancesImr',
  formAnswers = 'formAnswers',
  productsServices = 'productsServices',
  productsServicesTopCompanies = 'productsServicesTopCompanies'
}

export interface ExportDialogComponentInjectedData {
  type: ExportDialogTypeEnum;
  total?: number;
  limit?: number;
  where?: Record<string, any>;
  optionsForm: FormGroup;
}

export interface CreateExportParams {
  type: ExportDialogTypeEnum;
  timezone: string;
  language: string;
  where?: Record<string, any>;
}


export interface ToCreateExportParams {
  type: ExportDialogTypeEnum;
  where?: Record<string, any>;
  include?: string[];
}
